import { Instagram as InstagramIcon } from "lucide-react";
import Reveal from "@/components/Reveal";
import { CONTENT } from "@/content";

const POSTS = [
  { src: "/insta-pediatrie.jpg", alt: "Infographie : ostéopathie pédiatrique, accompagner bébé en douceur", featured: true },
  { src: "/insta-nerfs.jpg", alt: "Infographie : signes que votre système nerveux est en détresse" },
  { src: "/insta-douleur.jpg", alt: "Infographie : d'où vient la douleur dans le cou et le dos" },
  { src: "/insta-disques.jpg", alt: "Infographie : les pathologies des disques vertébraux" },
  { src: "/insta-cortisol.jpg", alt: "Infographie : tout savoir sur le cortisol" },
];

const Instagram = () => (
  <section id="instagram" className="relative overflow-hidden bg-ivory py-28 md:py-36" data-testid="instagram-section">
    <div aria-hidden="true" className="wash wash-sage-light blob -right-[12%] -top-[12%] h-[540px] w-[540px]" />
    <div aria-hidden="true" className="wash wash-beige blob-alt -bottom-[10%] -left-[10%] h-[460px] w-[460px]" style={{ animationDelay: "-11s" }} />
    <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
      <Reveal className="flex flex-wrap items-end justify-between gap-8">
        <div className="max-w-xl">
          <p className="text-xs font-medium uppercase tracking-[0.28em] text-gold">Sur Instagram</p>
          <h2 className="mt-5 font-serif text-4xl font-light leading-tight tracking-tight text-anthracite md:text-5xl">
            L'univers <em className="text-sage-dark">Corps en Mouvement</em>, en images
          </h2>
        </div>
        <a
          data-testid="instagram-follow-button"
          href={CONTENT.instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-shine rounded-md border border-sage px-8 py-4 text-sm font-medium uppercase tracking-[0.14em] text-taupe transition-colors duration-300 hover:bg-ivory"
        >
          {CONTENT.instagramHandle}
        </a>
      </Reveal>

      <div className="mt-14 grid grid-cols-2 gap-5 md:grid-cols-4">
        <Reveal className="col-span-2 row-span-2">
          <a
            data-testid="instagram-post-0"
            href={CONTENT.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative block h-full w-full overflow-hidden rounded-xl"
          >
            <img
              src={POSTS[0].src}
              alt={POSTS[0].alt}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <span className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-ivory/90 opacity-0 backdrop-blur-sm transition-opacity duration-300 group-hover:opacity-100">
              <InstagramIcon className="h-5 w-5 text-sage-dark" strokeWidth={1.2} />
            </span>
          </a>
        </Reveal>

        <Reveal delay={0.1}>
          <a
            data-testid="instagram-cta-tile"
            href={CONTENT.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-shine group flex h-full min-h-44 flex-col items-center justify-center gap-4 rounded-xl border border-sage-light/60 bg-sage-pale p-6 text-center transition-colors duration-500 hover:border-gold/40"
          >
            <img
              src={CONTENT.images.mascotte}
              alt={CONTENT.images.mascotteAlt}
              loading="lazy"
              className="h-20 w-20 rounded-full border-2 border-ivory object-cover object-top"
            />
            <span className="font-serif text-lg italic leading-snug text-anthracite">Conseils &amp; coulisses du cabinet</span>
            <span className="flex items-center gap-2 text-[10px] font-medium uppercase tracking-[0.22em] text-gold">
              <InstagramIcon className="h-4 w-4" strokeWidth={1.2} />
              Suivre
            </span>
          </a>
        </Reveal>

        {POSTS.slice(1).map((p, i) => (
          <Reveal key={p.src} delay={0.12 + i * 0.06}>
            <a
              data-testid={`instagram-post-${i + 1}`}
              href={CONTENT.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative block aspect-square w-full overflow-hidden rounded-xl"
            >
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-ivory/90 opacity-0 backdrop-blur-sm transition-opacity duration-300 group-hover:opacity-100">
                <InstagramIcon className="h-5 w-5 text-sage-dark" strokeWidth={1.2} />
              </span>
            </a>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <p className="mt-10 text-center text-xs font-light tracking-wide text-taupe/70" data-testid="instagram-note">
          Retrouvez toutes ces infographies, et bien plus, directement sur Instagram.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Instagram;
